import './header.scss'

import {
  useEffect,
  useState
} from 'react'

import {
  Input,
  Layout,
  Radio
} from 'antd'
import IconHelp from 'assets/svgs/IconHelp.svg'
import iconLink from 'assets/svgs/link-icon.svg'
import iconLogout from 'assets/svgs/logout-icon.svg'
import iconNoti from 'assets/svgs/notification.svg'
import {
  DEVICE_UUID,
  STORAGE_TOKEN_KEY
} from 'configs/constant'
import {
  HELP,
  HOME,
  LOGIN,
  SEARCH
} from 'configs/path'
import {
  useAppDispatch,
  useAppSelector
} from 'hooks'
import { useTranslation } from 'react-i18next'
import {
  Link,
  useNavigate,
  useSearchParams
} from 'react-router-dom'
import { logout } from 'services/authService'
import { removeImageBookMark } from 'services/magazineService'
import { bindParams } from 'utilities/helpers'
import Notification from 'web/Notification/Notification'

import { SearchOutlined } from '@ant-design/icons'

import { removeAllBookmark } from '../../../redux/slices/bookmarksSlice'
import { removeAllPage } from '../../../redux/slices/rememberPageSlice'

interface Props {
  hideSearch?: boolean
  hideAction?: boolean
}

const HeaderPC: React.FC<Props> = ({ hideAction, hideSearch }) => {
  const { setting } = useAppSelector((s) => s.app)
  const { bookmarks } = useAppSelector((s) => s.bookmarks)
  const [isOpenNotify, setOpenNotify] = useState(false)
  const { t } = useTranslation()
  const navigate = useNavigate()
  const app = useAppSelector((s) => s.app.app_id)
  const dispatch = useAppDispatch()
  const [searchParams] = useSearchParams()
  const [typeSearch, setTypeSearch] = useState(0)
  const [query] = useSearchParams()

  useEffect(() => {
    if (query.get('keyword')) {
      setTypeSearch(Number(query.get('typeSearch')))
    }
  }, [query.get('keyword')])

  const handleSearch = (value: any) => {
    if (value.length) {
      navigate(
        bindParams(SEARCH, {
          app: app
        }) + `?keyword=${encodeURIComponent(value)}&typeSearch=${typeSearch}`
      )
    }
  }
  const handleLogout = async () => {
    const sourceList = bookmarks.reduce((sources: any[], current) => {
      const filterSource = current.pages.map((page) => page.source)
      const list = [...sources, ...filterSource]
      return list
    }, [])
    await removeImageBookMark(sourceList)
    await logout({
      app_id: app,
      device_token: localStorage.getItem(DEVICE_UUID) || ''
    })
    localStorage.removeItem(STORAGE_TOKEN_KEY)
    dispatch(removeAllBookmark())
    dispatch(removeAllPage())
    navigate(
      bindParams(LOGIN, {
        app: app
      })
    )
  }
  return (
    <Layout.Header className="header_container">
      <div className="logo-container logo-container--pc">
        <Link
          to={bindParams(HOME, {
            app: app
          })}
        >
          <img src={setting?.logo_url} />
        </Link>
      </div>

      <div className="header_container__wrapper">
        {!hideSearch && (
          <div className="header_container_wrapper">
            <Input.Search
              allowClear
              enterButton={
                <button className="header_container__search">
                  <SearchOutlined />
                  <p>{t('search')}</p>
                </button>
              }
              size="large"
              onSearch={handleSearch}
              defaultValue={searchParams.get('keyword') || ''}
            />
            <Radio.Group
              onChange={(e) => setTypeSearch(e.target.value)}
              value={typeSearch}
              options={[
                { label: t('search_with_title'), value: 0 },
                { label: t('search_with_content'), value: 1 }
              ]}
              defaultValue={0}
            />
          </div>
        )}
        {!hideAction && (
          <div className="action-container">
            <div className="logo-container logo-container--mobile">
              <Link
                to={bindParams(HOME, {
                  app: app
                })}
              >
                <img src={setting?.logo_url} />
              </Link>
            </div>
            <div className="action-item" onClick={() => setOpenNotify(true)}>
              <img
                src={iconNoti}
                alt="noti_icon"
                style={{
                  transform: 'scale(1.2)'
                }}
              />
              <span>{t('notification')}</span>
            </div>
            <Link
              to={bindParams(HELP, {
                app: app
              })}
              className="action-item"
              target="_blank"
            >
              <img src={IconHelp} alt="IconHelp" />
              <span>{t('help')}</span>
            </Link>
            <Link className="action-item" to={setting.login_url} target="_blank">
              <img src={iconLink} alt="link_icon" />
              <span>{t('link')}</span>
            </Link>
            <div className="action-item" onClick={handleLogout}>
              <img src={iconLogout} alt="logout_icon" />
              <span>{t('logout')}</span>
            </div>
          </div>
        )}
      </div>

      {isOpenNotify && <Notification isOpenModal={isOpenNotify} setOpenModal={setOpenNotify} />}
    </Layout.Header>
  )
}

export default HeaderPC
